export enum PlayerClassType {
    Fighter,
    Tank,
    Sniper,
    Scout,
    Healer
}